"use client";
import React from "react";
import classNames from "classnames";
import useViewMore from "../../useViewMore";

import styles from "./RemoteDetail.mobile.module.scss";

export default function RemoteDetail({ dictionary, data }) {
  const { showMore, expand, setExpand, viewMoreRef } = useViewMore();

  if (data) {
    const not_open_country_list = data.not_open_country_list || [];
    const open_country_list = data.open_country_list || [];
    const language_require_list = data.language_require_list || [];

    return (
      <div className={styles.remoteDetail}>
        <h4>{data.title}</h4>
        <div className={styles.viewMoreContent} ref={viewMoreRef}>
          {not_open_country_list.length ? (
            <div>
              <p>
                {not_open_country_list[0]}&nbsp;&nbsp;{not_open_country_list[1]}
              </p>
            </div>
          ) : open_country_list.length ? (
            <p>
              {data.open_country_text}：{open_country_list.join(" | ")}
            </p>
          ) : null}
        </div>
        {showMore ? (
          <span
            className={classNames({
              [styles.viewMore]: true,
              [styles.close]: expand
            })}
            onClick={() => setExpand((state) => !state)}
          >
            {!expand ? dictionary.content.viewAll : dictionary.content.viewLess}
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='14'
              height='14'
              viewBox='0 0 14 14'
              fill='none'
            >
              <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M11.5148 4.55959C11.7173 4.76208 11.7173 5.09039 11.5148 5.29288L7.36667 9.44103C7.16417 9.64352 6.83587 9.64352 6.63337 9.44103L2.48522 5.29288C2.28273 5.09039 2.28273 4.76208 2.48522 4.55959C2.68772 4.35709 3.01602 4.35709 3.21852 4.55959L7.00002 8.34108L10.7815 4.55959C10.984 4.35709 11.3123 4.35709 11.5148 4.55959Z'
                fill='#7D7D7D'
              />
            </svg>
          </span>
        ) : null}
        {language_require_list?.length ? (
          <p>
            {data.language_require_text}：{language_require_list.join(" | ")}
          </p>
        ) : null}
      </div>
    );
  }
  return null;
}
